import { installments } from 'utils/constants'
import { formatPrice } from 'utils'

export const getInstallmentsList = total => {
  const { maximumQty, minimumPrice } = installments
  const compiledInstallments = []

  if (total < minimumPrice) {
    compiledInstallments.push({
      label: `${1}x de R$ ${formatPrice(total)}`,
      value: 1
    })

    return compiledInstallments
  }

  for (let inst = 1; inst <= maximumQty; inst++) {
    compiledInstallments.push({
      label: `${inst}x de R$ ${formatPrice(total / inst)}`,
      value: inst
    })
  }

  return compiledInstallments
}
